import { withStyle } from 'baseui'
import {Spinner as BaseSpinner} from 'baseui/spinner'

export const Spinner = withStyle(BaseSpinner, {
  $size: 16,
  borderLeftColor: '#b5b5b5',
  borderRightColor: '#b5b5b5',
  borderBottomColor: '#b5b5b5',
  borderTopColor: '#fff',
})